import React, { useState, useEffect } from 'react'
import FilterMenu from '../components/FilterMenu';
import './ProductosPage.scss';
import { ProductoCard } from '../components/ProductoCard'
import { useNavigate } from 'react-router-dom';
import Pagination from '@material-ui/lab/Pagination';
import { connect as connectRedux } from 'react-redux'
import { setSelectedProductosListRouteOrigin, setSelectedCollection, pushFilters, resetFilters, setProductsToShow, setProductsChild, setProductsCategory, setPaginationState, showSpinner } from '../actions'
import MyHeader from '../components/MyHeader';
import { filterAll } from '../hooks/filterProducts'
import { CategoryFilter } from '../filters/CategoryFilter'
import { CategoryNewFilter } from '../filters/CategoryNewFilter'
import { CollectionFilter } from '../filters/CollectionFilter'
import { FormasFilter } from '../filters/FormasFilter';
import { scrollBodyTop } from '../hooks/scrollPosition';
import { DiameterFilter } from '../filters/DiameterFilter';
import { ColoresFilter } from '../filters/ColoresFilter';
import { DeromaLogo, NotFoundIcon } from '../utils/icons'
import { HoleFilter } from '../filters/HoleFilter';
import { CharacteristicFilter } from '../filters/CharacteristicFilter';
import { SearchFilter } from '../filters/SearchFilter';
import { filter } from 'lodash';
import { NewFilter } from '../filters/NewFilter';
import BrandChosenBanner from './BrandChosenBanner';
import { BRANDCHOSEN, CambiarColoresPrincipales } from '../hooks/config';
import { useLocation } from 'react-router-dom';
const ProductosPage = (props) => {
    const location = useLocation();
    console.log("produtosPage",props);
    const navigate = useNavigate(); 
    const ITEMS_PER_PAGE = 24
    const { paginationState } = props
    const [pageProducts, setPageProducts] = useState([])
    const [showFilters, setShowFilters] = useState(false)
    const [inputSearch, setInputSearch] = useState('')

    useEffect(() => {
        scrollBodyTop()
    }, [])

    useEffect(() => {
        // if (_.isEmpty(props.filters) && props.productsTable !== 'allProductsSearch') {
        //     return
        // }
        // if(props.filters[0] && props.filters[0].categoryName == 'Outlet'){
        //   changeBrandGlobal().then((marcaCambiada)=>{
        //       if(marcaCambiada == false){
        //       }
        //   })
        // }
        CambiarColoresPrincipales()
        let filters = []
        for (let i = 0; i < props.filters.length; i++) {
            const filter = props.filters[i];
            if (filter.filterType === 'category' && (props.productsTable === 'allProducts' || props.productsTable === 'allProductsSearch')) {
                if (filter.categoryName === 'Nuevo') {
                    filters.push(new CategoryNewFilter(filter.categoryName))
                } else {
                    filters.push(new CategoryFilter(filter.categoryName))
                }
                filterAll(props.allProducts, filters).then(resultado => {
                    props.setProductsCategory(resultado)
                })
            }
            if (filter.filterType === 'category' && (props.productsTable === 'allProductsOutlet' || props.productsTable === 'allProductsExpositors' || props.productsTable === 'allProductsPromoA' || props.productsTable === 'allProductsPromoB' || props.productsTable === 'allProductsPromoC' || props.productsTable === 'allProductsImplantations')) {
                if (filter.categoryName !== 'Outlet' && filter.categoryName !== 'Expositors' && filter.categoryName !== 'PromoA' && filter.categoryName !== 'PromoB' && filter.categoryName !== 'PromoC' && filter.categoryName !== 'Implantations') {
                    filters.push(new CategoryFilter(filter.categoryName))
                } else {
                    props.resetFilters()
                }
                props.setProductsCategory(props.allProducts)
            }

            if (filter.filterType === 'collection') {
                filters.push(new CollectionFilter(filter.collectionName))
            }
            if (filter.filterType === 'formas') {
                filters.push(new FormasFilter(filter.formasName))
            }
            if (filter.filterType === 'diametro') {
                filters.push(new DiameterFilter(filter.minMaxDiameter))
            }
            if (filter.filterType === 'colores') {
                filters.push(new ColoresFilter(filter.color))
            }
            if (filter.filterType === 'hole') {
                filters.push(new HoleFilter(filter.containHole))
            }
            if (filter.filterType === 'characteristic') {
                filters.push(new CharacteristicFilter(filter.characteristicName))
            }
            if (filter.filterType === 'search') {
                filters.push(new SearchFilter(filter.searchName))
            }
            if (filter.filterType === 'new') {
                filters.push(new NewFilter('nuevo'))
            }
        }
        if (filters.length > 0) {
            filterAll(props.allProducts, filters).then(resultado => {
                props.setProductsChild(resultado)
                props.setProductsToShow(resultado)
            })
        } else {
            const products = props.allProducts[BRANDCHOSEN] ? props.allProducts[BRANDCHOSEN] : props.allProducts
            props.setProductsCategory(products)
            props.setProductsChild(products)
            props.setProductsToShow(products)
        }
        props.showSpinner(false)
    }, [props.filters])

    useEffect(() => {
        console.log("location",location?.pathname);
        props.setSelectedProductosListRouteOrigin(location.pathname)
        loadProductsOfPage(paginationState).then(()=>{})
    }, [props.productsToShow])

    const handleSearchProducts = (event) => {
        setInputSearch(event.target.value)
        const searchFilter = new SearchFilter(event.target.value)
        props.pushFilters(searchFilter)
    }

    const numberOfPages = () => {
        return Math.ceil(props.productsToShow.length / ITEMS_PER_PAGE)
    }

    const handlePaginationChange = (event, value) => {
        scrollBodyTop()
        props.setPaginationState(value)
        loadProductsOfPage(value)
    }

    const loadProductsOfPage = (page) => {
      return new Promise((res)=>{
        setPageProducts([])
        const firstItemToShow = (page * ITEMS_PER_PAGE) - ITEMS_PER_PAGE
        const aux = props.productsToShow.slice(firstItemToShow, firstItemToShow + ITEMS_PER_PAGE)
        setPageProducts(aux)
        res()
      })
    }

    const handleShowFilters = () => {
        setShowFilters(!showFilters)
    }

    const handleClickGoProduct = (url) => {
        scrollBodyTop()
        navigate(url);
    }

    return (
        <div className="productos-page-container">
            <MyHeader />
            <div className="productos-page-content">
                <div className="search">
                    <div className="search-input">
                        <div className="icon">
                            <i className="material-icons">search</i>
                        </div>
                        <div className="input-block">
                            <div className="input">
                                <input placeholder="Buscar producto" name="search" type="text" value={inputSearch} onChange={handleSearchProducts} />
                            </div>
                        </div>
                    </div>
                    <div className="button-filter" onClick={handleShowFilters}>
                        <p>Filtros</p>
                    </div>
                </div>
                {showFilters &&
                    <div className="filters movile">
                        <FilterMenu />
                    </div>
                }
                <div className="filters desktop">
                    <FilterMenu />
                </div>
                <div className="products-content">
                  <div className="brand-chosen-banner">
                      <BrandChosenBanner />
                  </div>

                  <div className="paginador paginador-sup">
                      {numberOfPages() >= 2 &&
                        <Pagination
                            count={numberOfPages()}
                            defaultPage={props.paginationState}
                            page={props.paginationState}
                            onChange={handlePaginationChange}
                            size="small"
                        />
                      }
                  </div>
                    {props.productsToShow.length > 0 ?
                        <div className="products" data-equalizer data-equalize-by-row="true">
                            {pageProducts.length > 0 && Array.isArray(pageProducts) && pageProducts.map(product => {
                                return (
                                    <div key={product.ID} className="product-container pointer" data-equalizer-watch>
                                        {product.Descripcion.toLowerCase().indexOf('mix ') > -1 &&
                                            <div onClick={() => handleClickGoProduct(`/expositor/${product.ID}`)}>
                                                <ProductoCard producto={product} allProducts={props.allProducts} productsTable={props.productsTable} />
                                            </div>
                                        }
                                        {product.Descripcion.toLowerCase().indexOf('surtido ') > -1 &&
                                            <div onClick={() => handleClickGoProduct(`/implantacion/${product.ID}`)}>
                                                <ProductoCard producto={product} allProducts={props.allProducts} productsTable={props.productsTable} />
                                            </div>
                                        }
                                        {product.Descripcion.toLowerCase().indexOf('mix ') == -1 && product.Descripcion.toLowerCase().indexOf('surtido ') == -1 &&
                                            <div onClick={() => handleClickGoProduct(`/producto/${product.ID}`)}>
                                                <ProductoCard producto={product} allProducts={props.allProducts} productsTable={props.productsTable} />
                                            </div>
                                        }
                                    </div>
                                )
                            })}
                        </div>
                        :
                        <div className="sin-productos">
                            <div className="icon">
                                <NotFoundIcon size={50} />
                            </div>
                            <div className="text">
                                <p>Producto no encontrado</p>
                            </div>
                        </div>
                    }
                    {numberOfPages() >= 2 &&
                        <div className="paginador">
                            <Pagination
                                count={numberOfPages()}
                                defaultPage={props.paginationState}
                                page={props.paginationState}
                                onChange={handlePaginationChange}
                                size="small"
                            />
                        </div>
                    }
                </div>
            </div>

        </div>
    )
}


const mapStateToProps = state => state

const mapDispatchToProps = {
    setSelectedProductosListRouteOrigin,
    setSelectedCollection,
    pushFilters,
    resetFilters,
    setProductsToShow,
    setProductsChild,
    setPaginationState,
    setProductsCategory,
    showSpinner
}
export default connectRedux(mapStateToProps, mapDispatchToProps)(ProductosPage)